import { Input } from 'element-ui';
export default {
	extends: Input,
	props: {
		ariaControls: {
			required: false
		}
	}
};
